import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import axios from 'axios'

Vue.use(Vuex)

const state = {
  loaded: true,
  changed:false,
  dataitems: false,
  patient: {},
  site: {},
  period: false,
  periods: [],
  questionnaire: {},
  questionnaires: [],
  errors: {},
  records: {},
  isSaving: false,
  patientCount:0,
  consentedCount:0
}

// actions
const actions = {

  getQuestionnaires({ commit, state }, params) {
    state.loaded = false
    return axios.get('/api/questionnaires', params)
      .then((resp) => {
        commit(types.GET_QUESTIONNAIRES, resp.data)
      });
  },
  getPatientSite({ commit, state }, params) {
    state.loaded = false
    return axios.get('/api/patient_site', params)
      .then((resp) => {
        commit(types.GET_PATIENT_SITE, resp.data)
      });
  },

  getPatientOverview({ commit, state }, params) {
    state.loaded = false
    state.period = false
    return axios.post('/api/patient_overview_data', params)
      .then((resp) => {
        commit(types.GET_PATIENT_OVERVIEW, resp.data)
      });
  },
  getPatientPeriodOverview({ commit, state }, params) {
    state.loaded = false
    return axios.post('/api/patient_period_overview_data', params)
      .then((resp) => {
        commit({
          type: types.GET_PATIENT_PERIOD_OVERVIEW,
          data: resp.data,
          params
        })
      });
  },
  getPatientCount({ commit, state }) {
    return axios.get('/api/patient_count')
      .then((resp) => {
        commit({
          type: types.GET_PATIENT_COUNT,
          data: resp.data,
        })
      });
  },
  getConsentedCount({ commit, state }) {
    return axios.get('/api/consented_count')
      .then((resp) => {
        commit({
          type: types.GET_CONSENTED_COUNT,
          data: resp.data,
        })
      });
  },
  getQuestionnaireData({ commit, state }, params) {
    state.loaded = false
    return axios.get('/api/admin/questionnaire_data', params)
      .then((resp) => {
        commit(types.GET_QUESTIONNAIRE_DATA, resp.data)
        commit(types.SET_RECORDS, resp.data)
      });
  },
  getPatientQuestionnaireData({ commit, state }, params) {
    state.loaded = false
    return axios.get('/api/patient_questionnaire_data', params)
      .then((resp) => {
        commit(types.GET_QUESTIONNAIRE_DATA, resp.data)
        commit(types.SET_RECORDS, resp.data)
      });
  },
  resetQuestionnaireData({ commit, state }, params) {
    state.loaded = false

  },
  setPeriod({ commit, state }, params) {
    commit(types.SET_PERIOD, params)
  },
  updatePeriodDates({ commit, state }, params) {
    state.loaded = false
    return axios.post('/api/update_period_dates', params)
      .then((resp) => {
        commit(types.UPDATE_PERIOD_DATES, resp.data)
      });
  },
  resendIssueNotification({ commit, state }, params) {
    return axios.post('/api/resend_issue_invitation', params)
      .then((resp) => {
        commit(types.UPDATE_PERIOD_DATES, resp.data)
      });
  },
  saveQuestionnaireRecords({ commit, state }, request) {
    this.isSaving = true
    return axios.post('/api/admin/questionnaire', request)
      .then((resp) => {
        resp.request = request
        commit(types.SAVE_QUESTIONNAIRE_RECORDS, resp)
      });
  },
  savePatientQuestionnaireRecords({ commit, state }, request) {
    return axios.post('/api/patient_questionnaire', request)
      .then((resp) => {
        resp.request = request
        commit(types.SAVE_QUESTIONNAIRE_RECORDS, resp)
      });
  },
  saveEntryDate({ commit, state }, request) {
    this.isSaving = true
    return axios.post('/api/admin/entry_date', request)
      .then((resp) => {
        resp.request = request
        commit(types.SAVE_ENTRY_DATE, resp)
      });
  },
  getPatientDetails({ commit, state }, request) {
    state.loaded = false
    return axios.post('/api/admin/patient_details/', request)
      .then((resp) => {
        commit(types.GET_PATIENT, resp.data)
      })

  },
  savePatientDetails({ commit, state }, data) {
    this.isSaving = true
    return axios.post('/api/admin/save_patient', data)
      .then((resp) => {
        commit(types.SAVE_PATIENT, resp.data)
        commit(types.UPDATE_ERRORS, {})
      })
      .catch((error) => {
        commit(types.UPDATE_ERRORS, {})
        commit(types.UPDATE_ERRORS, error.response.data.errors)
      });
  },
  update({ commit, state }, data) {
    commit(types.UPDATE, data)
  },
  updateRecord({ commit, state }, data) {
    commit(types.UPDATE_RECORD, data)
  },
  updateErrors({ commit, state }, errors) {
    commit(types.UPDATE_ERRORS, errors)
  }
  
}

// // getters
const getters = {
  //   getError: (state) => (di) => {
  //     return state.errors[di]
  //   }
}
// mutations
const mutations = {

  [types.GET_PATIENT_COUNT](state, resp) {
    state.patientCount = resp.data
  },
  [types.GET_CONSENTED_COUNT](state, resp) {
    state.consentedCount = resp.data
  },
  // [types.GET_PATIENTS_ISSUES](state, data) {
  //   _.each(state.patients,(p,i)=>{
  //     var pissues = _.find(data.patients,(dp)=>dp.id==p.id)
  //     if(pissues&&state.patients[i].id == p.id){ 
  //       Vue.set(state.patients[i], 'issues', pissues.issues);
  //     }
  //   })
  //   state.ui.patients.pagination.issues_loaded = true
  // },
  [types.GET_PATIENT_OVERVIEW](state, data) {
    state.patient = data.patient
    state.periods = data.periods
    state.loaded = true
  },
  [types.GET_PATIENT_PERIOD_OVERVIEW](state, resp) {
    state.patient = resp.data.patient
    state.periods = resp.data.periods
    state.questionnaires = resp.data.questionnaires
    var period = _.find(state.periods, (p) => {
      return resp.params.period == p.issue.name
    })
    state.period = period
    state.loaded = true
  },
  [types.GET_QUESTIONNAIRES](state, data) {
    state.patient = data.patient
    state.site = data.site
    state.periods = data.periods
    state.questionnaires = data.questionnaires
    state.loaded = true
  },
  [types.GET_PATIENT_SITE](state, data) {
    state.site = data.site
    state.loaded = true
  },
  [types.GET_QUESTIONNAIRE_DATA](state, data) {
    state.dataitems = data.dataitems
    state.questionnaire = data.questionnaire
    state.defaults = data.defaults
    state.defaultTemplate = data.defaultTemplate
    state.validation = data.validation
    if (data.patient) {
      state.patient = data.patient
      state.site = data.site
      state.period = data.period
      state.periods = data.periods
      if (data.questionnaires) state.questionnaires = data.questionnaires
    }
    state.loaded = true

    // console.log('GET_QUESTIONNAIRE_DATA',data)
  },
  [types.SAVE_QUESTIONNAIRE_RECORDS](state, resp) {
    var req = resp.request;
    var data = resp.data;
    var q = state.questionnaires.find((q) => { return state.questionnaire.id === q.id });
    var model_type = state.questionnaire.model_type
    if (q && q.patient_questionnaire) q.patient_questionnaire.valid = data.records.valid;
    if ((model_type == 'Oneshot' || model_type == 'ScheduledOneshot'))
      state.patient[req.name] = data.records;

    if (model_type == 'Encounter' && $.isArray(state.patient[req.name]) && state.encounter)
      var index = state.patient[req.name].findIndex(function(rec) {
        return rec.encounter_id == state.encounter.id
      })


    /* patient[req.name] is array */
    if (model_type == 'Scheduled' && $.isArray(state.patient[req.name]) && state.period) {
      var index = state.patient[req.name].findIndex(function(rec) {
        return rec.issue == state.period.issue_id
      })
    }
    if (index > -1) {
      state.patient[req.name][index] = data.records;
    } else if ($.isArray(state.patient[req.name])) {

      state.patient[req.name].push(data.records);
    }
    Vue.set(state, 'records', data.records);
    state.recordsSet = true;
    state.recordsChanged = false;
    state.isSaving = false;

  },
  [types.SAVE_ENTRY_DATE](state, data) {
    this.isSaving = false
  },
  [types.UPDATE_PERIOD_DATES](state, data) {
    state.loaded = false
    state.periods = data.periods
    if(state.period)
      state.period = _.find(data.periods,(p)=>{ return p.id == state.period.id })

  },
  [types.SET_RECORDS](state, data) {
    if (data.questionnaire) {
      var name = data.questionnaire.name
      var model_type = data.questionnaire.model_type
      var records = state.patient[name]
      if (model_type == 'Oneshot') state.records = records;
      if (model_type == 'Encounter' && $.isArray(records) && state.encounter) {
        records = records.find(function(rec) {
          return rec.encounter_id == state.encounter.id
        })
      }
      if ((model_type == 'Scheduled' || model_type == 'ScheduledOneshot') &&
        $.isArray(records) && state.period) {
        records = records.find(function(rec) {
          return rec.issue == state.period.issue_id
        })
      }
      if (!records) {
        records = _.clone(state.defaults)
        // console.log('using defaults',state.records,records)
      }
    } else {
      records = state.patient
    }
    state.records = records
    if(state.period && state.period.entry_date){
     if(!state.records.entry_date) state.records.entry_date = state.period.entry_date
    }
  },
  [types.SAVE_PATIENT](state, data) {
    state.patient = data.patient
    state.isSaving = false
    Vue.router.push({ name: 'patient_overview', params: { patient: data.patient.code } })
  },
  [types.GET_PATIENT](state, data) {
    state.patient = data.patient
    if(!state.patient.user) state.patient.user = {}
    state.loaded = true

  },
  [types.UPDATE](state, data) {
    _.each(data, (value, field) => {
      state[field] = value
    })
  },
  [types.UPDATE_RECORD](state, data) {
    state.records[data.field] = data.value
  },
  [types.UPDATE_ERRORS](state, errors) {
    // var errors = _.merge(_.clone(errors), state.errors)
    _.pickBy(errors, (errArr, field) => {
      if (!state.errors[field]) Vue.set(state.errors, field, errArr)
      state.errors[field] = errArr
    })
    if (_.isEmpty(errors)) state.errors = errors
    // state.errors = {
    //   WithinAgeRange:['invalid']
    // }

  },
}

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    return { ...modules, [name]: module }
  }, {})

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules
})
